import React, { useState } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import { PrimaryButton, Card, Block, Dropdown, TextField } from '@hz-design-system/web-ui';

import Styles from './SearchForm.module.scss';
import { buildLrpUrl } from '../../../../utils/url';

import TCategory from '../../../../types/TCategory';
import TAttribute from '../../../../types/TAttribute';
import { getCategoryOptions, getConditionOptions, getDistanceOptions } from './optionHelper';

type TSearchForm = {
  categories: Array<TCategory>;
  conditions?: Array<TAttribute>;
  lrpBaseUrl: string;
  query?: string;
};

const FIELDS = {
  CATEGORY: 'category',
  CONDITION: 'condition',
  POSTCODE: 'postcode',
  DISTANCE: 'distance',
};

const SearchForm = ({ categories, conditions = [], lrpBaseUrl, query }: TSearchForm) => {
  const { t } = useI18nContext();

  const [formValues, setFormValues] = useState({
    [FIELDS.CATEGORY]: '',
    [FIELDS.CONDITION]: '',
    [FIELDS.POSTCODE]: '',
    [FIELDS.DISTANCE]: '',
  });

  const handleChange = (name, val) => {
    setFormValues({
      ...formValues,
      [name]: val,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const category = formValues[FIELDS.CATEGORY];
    const condition = formValues[FIELDS.CONDITION];
    const postcode = formValues[FIELDS.POSTCODE];
    const distance = formValues[FIELDS.DISTANCE];

    const params = { query, distance, postcode, condition };

    window.location.href = buildLrpUrl(lrpBaseUrl, category, params);
  };

  const categoryOptions = getCategoryOptions(categories, t);
  const conditionOptions = getConditionOptions(conditions, t);
  const distanceOptions = getDistanceOptions(t);

  return (
    <Card className={Styles.Wrapper}>
      <Block padding="xs">
        <form className={Styles.FormWrapper} onSubmit={handleSubmit}>
          <div className={`${Styles.InputWrapper} ${Styles.CategoryWrapper}`}>
            <div className={Styles.Label}>{t('popularKeywords.searchForm.categoryLabel')}</div>

            <div className={Styles.CategoryDropdown}>
              <Dropdown
                className={Styles.CategoryDropdown}
                value={formValues[FIELDS.CATEGORY]}
                onChange={(e) => handleChange(FIELDS.CATEGORY, e.target.value)}
                options={categoryOptions}
              />
            </div>
          </div>

          <div className={`${Styles.InputWrapper} ${Styles.ConditionWrapper}`}>
            <div className={Styles.Label}>{t('popularKeywords.searchForm.conditionLabel')}</div>

            <div className={Styles.ConditionDropdown}>
              <Dropdown
                className={Styles.ConditionDropdown}
                value={formValues[FIELDS.CONDITION]}
                onChange={(e) => handleChange(FIELDS.CONDITION, e.target.value)}
                options={conditionOptions}
              />
            </div>
          </div>

          <div className={`${Styles.InputWrapper} ${Styles.PostcodeDistanceWrapper}`}>
            <div className={Styles.Label}>{t('popularKeywords.searchForm.postcodeAndDistanceLabel')}</div>

            <div className={Styles.PostcodeInputWrapper}>
              <TextField
                name={FIELDS.POSTCODE}
                className={Styles.PostcodeInput}
                value={formValues[FIELDS.POSTCODE]}
                onChange={(e) => handleChange(FIELDS.POSTCODE, e.target.value)}
                placeholder={t('popularKeywords.searchForm.postcodePlaceholder')}
              />
            </div>

            <Dropdown
              onChange={(e) => handleChange(FIELDS.DISTANCE, e.target.value)}
              options={distanceOptions}
              className={Styles.DistanceSelect}
            />
          </div>

          <div className={Styles.SearchButtonWrapper}>
            <PrimaryButton type="submit" as="button">
              {t('popularKeywords.searchForm.search')}
            </PrimaryButton>
          </div>
        </form>
      </Block>
    </Card>
  );
};

export default SearchForm;
